import React from 'react';

interface EntityMapProps {
  entityId: string;
}

export default function EntityMap({entityId}: EntityMapProps): JSX.Element {
  return <div>Entity map placeholder for {entityId}</div>;
}
